export enum FixedTariff {
    Yes = 'true',
    No = 'false',
    Both = 'both',
}
